module.exports = __webpack_public_path__ + "assets/img/swetha.09e352d6.jpg";